import cn from 'classnames';
import { useMemo } from 'react';

import styles from './styles.module.css';
import { DefaultWarehouseStep, FixedWarehouseStep } from '@pages/create-warehouse/ts';

export type WarehouseStepItem = {
  key: DefaultWarehouseStep | FixedWarehouseStep;
  label: String;
};

type Props = {
  className?: string;
  list: WarehouseStepItem[];
  currentStep: DefaultWarehouseStep | FixedWarehouseStep;
  availableSteps: Array<DefaultWarehouseStep | FixedWarehouseStep>;
};

export const StepList = ({ list, currentStep, availableSteps, className }: Props) => {
  const rootClass = cn(className ?? '', styles.root);

  return (
    <div className={rootClass}>
      <ul className={styles.list}>
        {list.map(({ key, label }) => (
          <li
            key={key}
            className={cn(styles.item, {
              [styles.current]: key === currentStep,
              // @ts-ignore
              [styles.available]: availableSteps.includes(key),
            })}
          >
            {label}
          </li>
        ))}
      </ul>
    </div>
  );
};
